import Api from 'Services/Api.service';
import Qs from 'qs';
import { apiAuthBaseUrl, apiBaseUrl } from 'config';
import { appLangCode, timeServerToLocal } from 'helpers';

class DmsApiService {

    getSettings = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/settings`);
        } catch (e) {
            // console.log('error while fetching user settings');
        }
    };

    getCurrentUser = async (config = {}) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/users/me`, config);
        } catch (e) {
            throw e;
        }
    };

    getThemeList = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/settings/themes`);
        } catch (e) {
            // console.log('error while fetching user themes');
        }
    };

    // setTheme = async (winId, theme) => {
    //     try {
    //         await Api.post(`${apiAuthBaseUrl}/settings/themes`, {
    //             ParentTabId: winId,
    //             Theme: theme
    //         })
    //     } catch (e) {
    //         console.log('error while set user theme')
    //     }
    // }

    getLanguageList = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/settings/languages`);
        } catch (e) {
            // console.log('error while fetching user languages');
        }
    };

    setLanguage = async (winId, language) => {
        try {
            await Api.post(`${apiAuthBaseUrl}/settings/languages`, {
                ParentTabId: winId,
                language: language,
            });
        } catch (e) {
            // console.log('error while set user language');
        }
    };

    setTheme = async (winId, theme) => {
        try {
            await Api.post(`${apiAuthBaseUrl}/settings/themes`, {
                ParentTabId: winId,
                Theme: theme,
            });
        } catch (e) {
            // console.log('error while set user theme');
        }
    };

    closeWindow = async id => {
        try {
            await Api.post(`${apiAuthBaseUrl}/tabs/${id}/close`);
        } catch (e) {
            throw Error('Fetch Jobs Error');
        }
    };

    getCompanies = async () => {
        try {
            const response = await Api.get(`${apiAuthBaseUrl}/companies`);
            return response.data;
        } catch (e) {
            throw Error('Fetch Companies Error');
        }
    };

    getJobs = async () => {
        try {
            const response = await Api.get(`${apiBaseUrl}/jobs`);
            return this._transformJobs(response.data);
        } catch (e) {
            throw Error('Fetch Jobs Error');
        }
    };

    getLicenses = async () => {
        try {
            const response = await Api.get(`${apiBaseUrl}/jobs/licenses`);
            return (response.data);
        } catch (e) {
            throw Error('Fetch Licenses Error');
        }
    };

    getJobsShortPaged = async (skip, take, licenseIds, searchTerm, jobPlannerId, jobPlannerStages) => {
        try {
          let queryParams = `skip=${skip}&take=${take}&searchTerm=${searchTerm || ""}`;
          if (licenseIds && licenseIds.length) {
            licenseIds.forEach((id) => {
              queryParams += `&licenseIds=${id}`;
            });
          }
          if (jobPlannerId) {
            queryParams += `&jobPlannerId=${jobPlannerId}`;
          }
          if (jobPlannerStages && jobPlannerStages.length) {
            jobPlannerStages.forEach((stage) => {
              queryParams += `&jobPlannerStages=${encodeURIComponent(stage)}`;
            });
          }
          const response = await Api.get(`${apiBaseUrl}/jobs/short/paged?${queryParams}`);
          return response.data;
        } catch (e) {
          throw Error("Error while fetching paged jobs");
        }
      };

    getJobsPlannerFilterLicenses = async (jobPlannerId) => {
        try {
          const response = await Api.get(
            `${apiBaseUrl}/jobs/planner/${jobPlannerId}/licenses`,
          );
          return response.data;
        } catch (e) {
          throw Error("Error while fetching job planner license filters");
        }
      };

    getJobsPlannerFilterStages = async (jobPlannerId) => {
        try {
          const response = await Api.get(
            `${apiBaseUrl}/jobs/planner/${jobPlannerId}/stages`,
          );
          return response.data;
        } catch (e) {
          throw Error("Error while fetching job planner stage filters");
        }
      };
      

    getJobsShort = async (tabType) => {
        try {
            const queryParams = tabType ? `?tabType=${tabType}` : '';
            const response = await Api.get(`${apiBaseUrl}/jobs/short${queryParams}`);
            return response.data;
        } catch (e) {
            throw Error('Fetch Jobs Error');
        }
    };

    getUniqueUnits = async () => {
        try {
            const response = await Api.get(`${apiBaseUrl}/units/unique`);
            return response.data;
        } catch (e) {
            throw Error('Fetch Units Error');
        }
    };

    getUniqueUnitsByCompanyId = async (companyId, config = {}) => {
        if (!companyId) {
            throw new Error('companyId is required')
        }
        try {
            const response = await Api.get(`${apiBaseUrl}/units/unique`, {
                ...config,
                headers: {
                    CompanyId: companyId,
                    ...(config.headers || {}),
                },
            })
            if (response?.status === 204) return []
            return Array.isArray(response?.data) ? response.data : []
        } catch (e) {
            throw Error('Fetch Units Error')
        }
    };

    getUniqueUnitsAll = async (config = {}) => {
        try {
            const response = await Api.get(`${apiBaseUrl}/units/unique/all`, config)
            if (response?.status === 204) return []
            return Array.isArray(response?.data) ? response.data : []
        } catch (e) {
            throw Error('Fetch Units Error')
        }
    };

    getJobsById = async id => {
        try {
            const response = await Api.get(`${apiBaseUrl}/jobs/${id}`);
            return this._transformJobs([response.data])[0];
        } catch (e) {
            throw Error('Fetch Jobs Error');
        }
    };

    getChannelsData = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/data/by-custom-channels`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getChannelsDataInitWithFilters = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/data/jobs/by-custom-channels/initialize/with-filters`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getChannelsDataInit = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/data/by-custom-channels/initialize`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getJobsChannelsDataInit = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/data/jobs/by-custom-channels/initialize`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getLastChannelsData = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/Data/by-custom-channels/last`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };


    // getChannelsData = async (channelIds) => {
    //     try {
    //         const response = await Api.get(`data`, {
    //             params: {channelIds: channelIds},
    //             paramsSerializer: function (params) {
    //                 return Qs.stringify(params, {arrayFormat: 'repeat'})
    //             }
    //         })
    //         return response.data
    //     } catch (e) {
    //         throw Error('Fetch Channels Data Error')
    //     }
    // }

    getChannelsDataByDaterange = async (from, to, channelIds) => {
        try {
            const response = await Api.get(`${apiBaseUrl}/data/by-daterange/${from}/${to}`, {
                params: { channelIds: channelIds },
                paramsSerializer: function (params) {
                    return Qs.stringify(params, { arrayFormat: 'repeat' });
                },
            });
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getChannelsDataByCustomAxis = async (channelsData) => {
        try {
            const response = await Api.post(`${apiBaseUrl}/data/by-custom-axis`, channelsData);
            return response.data;
        } catch (e) {
            throw Error('Fetch Channels Data Error');
        }
    };

    getItemTypes = async (lang) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/items/types`, {
                headers: {
                    'Accept-Language': appLangCode(lang),
                },
            });
        } catch (e) {
            throw Error('Fetch Item Types Error');
        }
    };

    syncTabWithServer = async (tabId, items, colors, companyId) => {
        try {

            return await Api.post(`${apiAuthBaseUrl}/tabs/items`, {
                tabId,
                items,
                time: new Date(),
                colors,
                companyId,
            }, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw Error('sync tab error');
        }
    };

    syncTabWithApiServer = async (tabId, items, colors, companyId, parentTabId) => {
        try {

            return await Api.post(`${apiBaseUrl}/tabs/items`, {
                tabId,
                items,
                time: new Date(),
                colors,
                companyId,
                parentTabId,
            }, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw Error('sync tab error');
        }
    };

    getTabColors = async (tabId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/tabs/${tabId}/colors`);
        } catch (e) {
            throw Error('Fetch Item Types Error');
        }
    };

    getTabColorsByCompanyId = async (tabId, companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/tabs/${tabId}/colors/by-companyid/${companyId}`);
        } catch (e) {
            throw Error('Fetch Item Types Error');
        }
    };

    postItem = async (tabId, item) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/tabs/${tabId}/items`, item);
        } catch (e) {
            throw Error('Putting Item Error');
        }
    };

    updateItem = async (tabId, itemId, item) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/tabs/${tabId}/items/${itemId}`, item);
        } catch (e) {
            throw Error('Updating Item Error');
        }
    };

    removeItem = async (tabId, itemId) => {
        try {
            return await Api.delete(`${apiAuthBaseUrl}/tabs/${tabId}/${itemId}`);
        } catch (e) {
            throw Error('Removing Item Error');
        }
    };

    _transformJobs = jobs => {
        if (!jobs)
            return [];
        // console.time('TransformJobs')
        // console.log(transformed)
        return jobs.map(job => {
            const units = job.units.map(unit => {
                const channels = unit.channels.map(channel => {
                    return {
                        ...channel,
                        jobId: job.id,
                        unitId: unit.id,
                        unitName: unit.nameLocalized,
                        unitCode: unit.code,
                        defaultUnit: channel.unit,
                    };
                });
                return {
                    ...unit,
                    channels,
                    jobId: job.id,
                };
            });

            return {
                ...job,
                startTime: this._fixTimeFormat(timeServerToLocal(job.startTime, job.timeZone)),
                stopTime: this._fixTimeFormat(timeServerToLocal(job.stopTime, job.timeZone)),
                units,
            };
        });
    };

    getTemplatesByCompanyId = async (id) => {
        try {
            return await Api.get(`${apiBaseUrl}/templates/by-companyid/${id}`);
        } catch (e) {
            throw e;
        }
    };

    getTemplatesByJobId = async (id) => {
        try {
            return await Api.get(`${apiBaseUrl}/templates/by-jobid/${id}`);
        } catch (e) {
            throw e;
        }
    };

    getTemplates = async () => {
        try {
            return await Api.get(`${apiBaseUrl}/templates`);
        } catch (e) {
            throw e;
        }
    };


    saveTemplate = async (tabId, name, templateId = null) => {
        try {
            return await Api.post(`${apiBaseUrl}/templates/save`, {
                tabId,
                templateId,
                name,
            });
        } catch (e) {
            throw e;
        }
    };

    loadTemplate = async (templateId, jobId, tabId) => {
        try {
            return await Api.post(`${apiBaseUrl}/templates/load`, {
                templateId,
                jobId,
                tabId,
            });
        } catch (e) {
            throw e;
        }
    };

    deleteTemplate = async (id) => {
        try {
            return await Api.delete(`${apiBaseUrl}/templates/${id}`);
        } catch (e) {
            throw e;
        }
    };

    getUsers = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/users`);
        } catch (e) {
            throw e;
        }
    };

    getUsersShort = async (config = {}) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/users/short`, config);
        } catch (e) {
            throw e;
        }
    };

    createUser = async (userInfo) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/users`, userInfo);
        } catch (e) {
            throw e;
        }
    };

    updateUser = async (userInfo) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/users`, userInfo);
        } catch (e) {
            throw e;
        }
    };

    deleteUser = async (id) => {
        try {
            return await Api.delete(`${apiAuthBaseUrl}/Users/${id}`);
        } catch (e) {
            throw e;
        }
    };

    getOneJobPasswords = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/JobPasswords`);
        } catch (e) {
            throw e;
        }
    };

    getOneJobPasswordsPaged = async (request, config = {}) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/JobPasswords/paged`, request, config);
        } catch (e) {
            throw e;
        }
    };

    getOneJobPasswordLink = async (id) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/JobPasswords/${id}/link`);
        } catch (e) {
            throw e;
        }
    };

    createOneJobPassword = async (jobId, companyId) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/JobPasswords`, { jobId: jobId, companyId: companyId });
        } catch (e) {
            throw e;
        }
    };

    createOneUnitPassword = async (unitId, companyId, unitPasswordInfo = null) => {
        try {
            const requestData = unitPasswordInfo 
                ? { ...unitPasswordInfo, unitUId: unitId, companyId: companyId }
                : { unitUId: unitId, companyId: companyId };
            return await Api.post(`${apiAuthBaseUrl}/JobPasswords`, requestData);
        } catch (e) {
            throw e;
        }
    };

    updateOneJobPassword = async (data) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/JobPasswords`, data);
        } catch (e) {
            throw e;
        }
    };

    updateIsEnabledOneJobPassword = async (id, isEnabled) => {

        try {
            const suffix = isEnabled ? 'disable' : 'enable';
            return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/${suffix}`);
            // if (isEnabled) {
            //     return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/disable`)
            // }
            // else
            //     return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/enable`)
        } catch (e) {
            throw e;
        }
    };

    // updateIsEnabledOneJobPassword = async (id, isEnabled) => {
    //
    //     try {
    //         const suffix = isEnabled ? 'disable' : 'enable'
    //         return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/${suffix}`)
    //         // if (isEnabled) {
    //         //     return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/disable`)
    //         // }
    //         // else
    //         //     return await Api.put(`${apiAuthBaseUrl}/jobpasswords/${id}/enable`)
    //     } catch (e) {
    //         throw e
    //     }
    // }

    deleteOneJobPassword = async (id) => {
        try {
            return await Api.delete(`${apiAuthBaseUrl}/JobPasswords/${id}`);
        } catch (e) {
            throw e;
        }
    };

    resendUserEmail = async (email) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/Users/email/resend`, { email: email });
        } catch (e) {
            throw e;
        }
    };

    getPasswordChangeToken = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/Users/password/change`);
        } catch (e) {
            throw e;
        }
    };

    getLicenseIds = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/licenses`);
        } catch (e) {
            throw e;
        }
    };

    getLicenseIdsByCompanyId = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/licenses/by-companyid/${companyId}`, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw e;
        }
    };

    refreshLicenses = async (companyId) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/licenses/refresh/${companyId}`);
        } catch (e) {
            throw e;
        }
    };

    getCompany = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/companies/${companyId}`);
        } catch (e) {
            throw e;
        }
    };

    getCompanyImage = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/companies/${companyId}/with-image`);
        } catch (e) {
            throw e;
        }
    };

    patchCompanySettings = async (companyId, settings) => {
        try {
            return await Api.patch(`${apiAuthBaseUrl}/companies/${companyId}/settings`, {
                companyId,
                settings,
            });
        } catch (e) {
            throw e;
        }
    };

    uploadCompanyImage = async (companyId, file) => {
        try {
            let fd = new FormData();
            fd.append('file', file);
            if (companyId)
                return await Api.post(`${apiAuthBaseUrl}/companies/${companyId}/image`, fd);
            else
                return await Api.post(`${apiAuthBaseUrl}/companies/image`, fd);
        } catch (e) {
            throw e;
        }
    };

    updateCompany = async (company) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/companies`, company);
        } catch (e) {
            throw e;
        }
    };

    getEvents = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/events/by-jobid/${jobId}`);
        } catch (e) {
            throw e;
        }
    };

    getJobProperties = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/JobProperties/by-jobid/${jobId}`);
        } catch (e) {
            throw e;
        }
    };

    getPumpingScheduleChannels = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/pumpingschedule/channels/by-jobid/${jobId}`);
        } catch (e) {
            throw e;
        }
    };

    getPumpingScheduleData = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/pumpingschedule/data/by-jobid/${jobId}?latestOnly=true`);
        } catch (e) {
            throw e;
        }
    };

    getWellbore = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/wellbore/by-jobid/${jobId}`);
        } catch (e) {
            throw e;
        }
    };

    getWellboreZoneSummaries = async (jobId) => {
        try {
            return await Api.get(`${apiBaseUrl}/wellbore/zone-summaries/by-jobid/${jobId}`);
        } catch (e) {
            throw e;
        }
    };

    getWellboreZoneSummary = async (jobId, zone) => {
        try {
            return await Api.get(`${apiBaseUrl}/wellbore/zone-summary/by-jobid/${jobId}/zone/${zone}`);
        } catch (e) {
            throw e;
        }
    };

    exportData = async (data) => {
        const fetchUrl = data.jobId
            ? `${apiBaseUrl}/DataExport/jobs`
            : `${apiBaseUrl}/DataExport/jobs/by-custom-channels`;
        try {
            return await Api.post(fetchUrl, data);
        } catch (e) {
            throw e;
        }
    };

    exportEventLoggerData = async (data) => {
        try {
            return await Api.post(`${apiBaseUrl}/DataExport/jobs/events`, data);
        } catch (e) {
            throw e;
        }
    };

    exportUnitsData = async (data) => {
        const fetchUrl = !data.channels
            ? `${apiBaseUrl}/DataExport/units`
            : `${apiBaseUrl}/DataExport/units/by-custom-channels`;
        try {
            return await Api.post(fetchUrl, data);
        } catch (e) {
            throw e;
        }
    };

    exportUnitsEventLoggerData = async (data) => {
        try {
            return await Api.post(`${apiBaseUrl}/DataExport/units/events`, data);
        } catch (e) {
            throw e;
        }
    };

    getExportDateTypes = async () => {
        try {
            return await Api.get(`${apiBaseUrl}/DataExport/types`);
        } catch (e) {
            throw e;
        }
    };

    getCompanyJobsShort = async (companyId, tabType) => {
        try {
            const queryParams = tabType ? `?tabType=${tabType}` : '';
            const response = await Api.get(`${apiBaseUrl}/jobs/short${queryParams}`, {
                headers: {
                    'CompanyId': companyId,
                },
            });
            return response.data;
        } catch (e) {
            throw e;
        }
    };

    getOneJobPasswordsByCompanyId = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/JobPasswords/by-companyid/${companyId}`, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw e;
        }
    };

    getUsersByCompanyId = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/users/by-companyid/${companyId}`, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw e;
        }
    };

    getUnits = async () => {
        try {
            return await Api.get(`${apiBaseUrl}/units/unique-by-uid`);
        } catch (e) {
            throw e;
        }
    };

    getUnitOptions = async (unitUId) => {
        try {
            return await Api.get(`${apiBaseUrl}/Units/${unitUId}/options`);
        } catch (e) {
            throw e;
        }
    };

    getIntegrationTypes = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/integrations/options/integration-types`)
        } catch (e) {
            throw e
        }
    }

    getIntegrationDateIntervals = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/integrations/options/date-intervals`)
        } catch (e) {
            throw e
        }
    }

    getIntegrations = async (companyId) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/integrations`, {
                headers: {
                    'CompanyId': companyId,
                },
            });
        } catch (e) {
            throw e
        }
    }

    getApiKeys = async (config = {}) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/apikeys`, config);
        } catch (e) {
            throw e;
        }
    };

    getApiKey = async (id, config = {}) => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/apikeys/${id}`, config);
        } catch (e) {
            throw e;
        }
    };

    createApiKey = async (apiKeyInfo, config = {}) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/apikeys`, apiKeyInfo, config);
        } catch (e) {
            throw e;
        }
    };

    updateApiKey = async (apiKeyInfo, config = {}) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/apikeys`, apiKeyInfo, config);
        } catch (e) {
            throw e;
        }
    };

    deleteApiKey = async (id, config = {}) => {
        try {
            return await Api.delete(`${apiAuthBaseUrl}/apikeys/${id}`, config);
        } catch (e) {
            throw e;
        }
    };

    createIntegration = async (integrationInfo) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/integrations`, integrationInfo);
        } catch (e) {
            throw e;
        }
    };

    testIntegration = async (integrationInfo, integrationType) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/integrations/${integrationType}/test-connection`, integrationInfo);
        } catch (e) {
            throw e;
        }
    };

    editIntegration = async (integrationInfo) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/integrations`, integrationInfo);
        } catch (e) {
            throw e;
        }
    };

    deleteIntegration = async (id) => {
        try {
            return await Api.delete(`${apiAuthBaseUrl}/integrations/${id}`, {
                
            });
        } catch (e) {
            throw e;
        }
    };

    getIntegrationLogs = async (id, from, to) => {
        try {
          const params = {};
    
          if (from) {
            params.from = from.toISOString();
          }
    
          if (to) {
            params.to = to.toISOString();
          }
    
          return await Api.get(`${apiAuthBaseUrl}/Integrations/${id}/logs`, { params });
        } catch (e) {
          console.error('Error in getIntegrationLogs:', e);
          throw e;
        }
      };

    _fixTimeFormat = str => str ? str.replace('T', ' ') : null;

    sendMessageToSns = async (messageInfo) => {
        try {
            return await Api.post(`${apiAuthBaseUrl}/devices/messages`, messageInfo);
        } catch (e) {
            throw e;
        }
    };

    getDevicesMessages = async () => {
        try {
            return await Api.get(`${apiAuthBaseUrl}/devices/messages`);
        } catch (e) {
            throw e;
        }
    };

    editDeviceMessage = async (messageInfo) => {
        try {
            return await Api.put(`${apiAuthBaseUrl}/devices/messages`, messageInfo);
        } catch (e) {
            throw e;
        }
    };

    getCatalog = async (entity, pageNumber = 1, pageSize = 20, companyId, searchTerm) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        let url = `${apiBaseUrl}/catalog/${entity}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (searchTerm != null && String(searchTerm).trim() !== '') {
            url += `&searchTerm=${encodeURIComponent(String(searchTerm).trim())}`;
        }
        return Api.get(url, config);
    };

    getCatalogPadsWithIncludes = async (
        pageNumber = 1,
        pageSize = 20,
        companyId,
        searchTerm,
        sortBy = 'updatedAt',
        sortOrder = 'desc',
    ) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        let url = `${apiBaseUrl}/catalog/pads/with-includes?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${encodeURIComponent(sortBy)}&sortOrder=${encodeURIComponent(sortOrder)}`;
        if (searchTerm != null && String(searchTerm).trim() !== '') {
            url += `&searchTerm=${encodeURIComponent(String(searchTerm).trim())}`;
        }
        return Api.get(url, config);
    };

    putCatalog = async (entity, payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.put(`${apiBaseUrl}/catalog/${entity}`, payload, config);
    };

    postCatalog = async (entity, payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/catalog/${entity}`, payload, config);
    };

    upsertCatalog = async (entity, payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/catalog/${entity}/upsert`, payload, config);
    };

    upsertCatalogPadsWithIncludes = async (payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/catalog/pads/with-includes/upsert`, payload, config);
    };

    deleteCatalog = async (entity, ids, companyId) => {
        const headers = { 'Content-Type': 'application/json' };
        if (companyId) headers.CompanyId = companyId;
        return Api.delete(`${apiBaseUrl}/catalog/${entity}`, {
            headers,
            data: JSON.stringify(ids),
        });
    };

    seedCatalog = async (companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/catalog/seed`, {}, config);
    };

    cleanupCatalog = async (companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/catalog/cleanup`, {}, config);
    };

    getJobsPlanner = async (pageNumber = 1, pageSize = 200, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.get(`${apiBaseUrl}/JobsPlanner?pageNumber=${pageNumber}&pageSize=${pageSize}`, config);
    };

    createJobsPlanner = async (payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/JobsPlanner`, payload, config);
    };

    upsertJobsPlanner = async (payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.post(`${apiBaseUrl}/JobsPlanner/upsert`, payload, config);
    };

    updateJobsPlanner = async (payload, companyId) => {
        const config = companyId ? { headers: { CompanyId: companyId } } : {};
        return Api.put(`${apiBaseUrl}/JobsPlanner`, payload, config);
    };

    deleteJobsPlanner = async (ids, companyId) => {
        const headers = { 'Content-Type': 'application/json' };
        if (companyId) headers.CompanyId = companyId;
        return Api.delete(`${apiBaseUrl}/JobsPlanner`, { headers, data: JSON.stringify(ids) });
    };

    uploadJobPlannerFile = async (file, companyId) => {
        const headers = { 'Content-Type': 'multipart/form-data' };
        if (companyId) headers.CompanyId = companyId;
        const formData = new FormData();
        formData.append('file', file);
        return Api.post(`${apiBaseUrl}/JobsPlanner/upload`, formData, { headers });
    };

    getUnitSettings = async ({ pageNumber, pageSize, sortBy, sortDescending, searchTerm }, config = {}) => {
        const params = {
            PageNumber: pageNumber,
            PageSize: pageSize,
            SortBy: sortBy,
            SortDescending: sortDescending,
        };
        if (searchTerm != null && String(searchTerm).trim() !== '') {
            params.SearchTerm = String(searchTerm).trim();
        }
        return Api.get(`${apiBaseUrl}/Subscriptions/unitsettings`, { ...config, params });
    };

    getUnitSettingsLogsUsage = async (
        { pageNumber, pageSize, sortBy, sortDescending, searchTerm, dataRetentionPeriod },
        config = {},
    ) => {
        const params = {
            PageNumber: pageNumber,
            PageSize: pageSize,
            SortBy: sortBy,
            SortDescending: sortDescending,
        };
        if (searchTerm != null && String(searchTerm).trim() !== '') {
            params.SearchTerm = String(searchTerm).trim();
        }
        if (dataRetentionPeriod != null && dataRetentionPeriod !== '') {
            params.DataRetentionPeriod = dataRetentionPeriod;
        }
        return Api.get(`${apiBaseUrl}/Subscriptions/UnitSettings/logs/usage`, { ...config, params });
    };

    patchUnitSettingsLogsUsageInterval = async (body, config = {}) =>
        Api.patch(`${apiBaseUrl}/Subscriptions/UnitSettings/logs/usage/interval`, body, {
            ...config,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...(config.headers || {}),
            },
        });

    patchUnitSettings = async (body, config = {}) =>
        Api.patch(`${apiBaseUrl}/Subscriptions/unitsettings`, body, {
            ...config,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...(config.headers || {}),
            },
        });

    getSubscriptionsSummary = async (dataRetentionPeriod, config = {}) => {
        const hasRetention =
            dataRetentionPeriod != null && String(dataRetentionPeriod).trim() !== '';
        return Api.get(`${apiBaseUrl}/Subscriptions/summary`, {
            ...config,
            ...(hasRetention
                ? {
                    params: {
                        ...config.params,
                        DataRetentionPeriod: dataRetentionPeriod,
                    },
                }
                : {}),
        });
    };

    getSubscriptionsDataRetentionPeriodOptions = async (config = {}) =>
        Api.get(`${apiBaseUrl}/Subscriptions/options/data-retention-periods`, config);

    getSubscriptionsDataRetentionPeriod = async (config = {}) =>
        Api.get(`${apiBaseUrl}/Subscriptions/data-retention-period`, config);

    patchSubscriptionsDataRetentionPeriod = async (body, config = {}) =>
        Api.patch(`${apiBaseUrl}/Subscriptions/data-retention-period`, body, {
            ...config,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...(config.headers || {}),
            },
        });

    postSubscriptionsPackageUpgradeConfirm = async (body, config = {}) =>
        Api.post(`${apiBaseUrl}/Subscriptions/package-upgrade/confirm`, body, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(config.headers || {}),
            },
        });

    getUnitSettingsLogs = async (
        {
            pageNumber,
            pageSize,
            sortBy,
            sortDescending,
            searchTerm,
            unitUIds,
            unitNames,
            actionBys,
        },
        config = {},
    ) => {
        const params = {
            PageNumber: pageNumber,
            PageSize: pageSize,
            SortBy: sortBy,
            SortDescending: sortDescending,
        };
        if (searchTerm != null && String(searchTerm).trim() !== '') {
            params.SearchTerm = String(searchTerm).trim();
        }
        if (Array.isArray(unitUIds) && unitUIds.length > 0) {
            params.UnitUIds = unitUIds;
        }
        if (Array.isArray(unitNames) && unitNames.length > 0) {
            params.UnitNames = unitNames;
        }
        if (Array.isArray(actionBys) && actionBys.length > 0) {
            params.ActionBys = actionBys;
        }
        const hasArrayParams = params.UnitUIds || params.UnitNames || params.ActionBys;
        return Api.get(`${apiBaseUrl}/Subscriptions/unitsettings/logs`, {
            ...config,
            params,
            ...(hasArrayParams
                ? {
                    paramsSerializer: (p) =>
                        Qs.stringify(p, { arrayFormat: 'repeat', skipNulls: true }),
                }
                : {}),
        });
    };

    removeUnitSettingsLogsEntries = async (body, config = {}) =>
        Api.delete(`${apiBaseUrl}/Subscriptions/unitsettings/logs`, {
            ...config,
            data: body,
            headers: {
                'Content-Type': 'application/json',
                ...(config.headers || {}),
            },
        });

    getFleetStandardChannelFields = async (fleetType, config = {}) => {
        if (fleetType == null || fleetType === '') {
            throw new Error('fleetType is required')
        }
        return Api.get(`${apiBaseUrl}/Fleet/standard-channel-fields/${fleetType}`, config)
    }

    createFleetStandardChannelField = async (payload, config = {}) => {
        if (!payload || typeof payload !== 'object') {
            throw new Error('payload is required')
        }
        return Api.post(`${apiBaseUrl}/Fleet/standard-channel-fields`, payload, config)
    }

    updateFleetStandardChannelField = async (id, payload, config = {}) => {
        const fieldId = Number(id)
        if (!Number.isFinite(fieldId)) {
            throw new Error('id is required')
        }
        if (!payload || typeof payload !== 'object') {
            throw new Error('payload is required')
        }
        return Api.put(`${apiBaseUrl}/Fleet/standard-channel-fields/${fieldId}`, payload, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(config.headers || {}),
            },
        })
    }

    deleteFleetStandardChannelField = async (id, config = {}) => {
        const fieldId = Number(id)
        if (!Number.isFinite(fieldId)) {
            throw new Error('id is required')
        }
        return Api.delete(`${apiBaseUrl}/Fleet/standard-channel-fields/${fieldId}`, config)
    }

    getUnitByUnitUId = async (unitUId, config = {}) => {
        if (unitUId == null || unitUId === '') {
            throw new Error('unitUId is required')
        }
        return Api.get(`${apiBaseUrl}/Units/by-unit-uid/${encodeURIComponent(unitUId)}`, config)
    }

    initializeFleetMappings = async (payload, config = {}) => {
        if (!payload || typeof payload !== 'object') {
            throw new Error('payload is required')
        }
        return Api.post(`${apiBaseUrl}/Fleet/initialize-mappings`, payload, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(config.headers || {}),
            },
        })
    }

    getFleetChannelMappings = async (params = {}, config = {}) => {
        const query = {}
        if (params.equipmentType != null && params.equipmentType !== '') {
            query.equipmentType = params.equipmentType
        }
        if (params.unitUId != null && params.unitUId !== '') {
            query.unitUId = params.unitUId
        }
        if (params.licenseId != null && params.licenseId !== '') {
            query.licenseId = params.licenseId
        }
        return Api.get(`${apiBaseUrl}/Fleet/channel-mappings`, {
            ...config,
            params: {
                ...query,
                ...(config.params || {}),
            },
        })
    }

    updateFleetChannelMapping = async (id, payload, config = {}) => {
        const mappingId = Number(id)
        if (!Number.isFinite(mappingId)) {
            throw new Error('id is required')
        }
        if (!payload || typeof payload !== 'object') {
            throw new Error('payload is required')
        }
        return Api.put(`${apiBaseUrl}/Fleet/channel-mappings/${mappingId}`, payload, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(config.headers || {}),
            },
        })
    }

    getFleetPressureChannels = async (jobIds = []) => {
        const ids = [...new Set(jobIds.filter((id) => id != null))]
        if (!ids.length) return []
        const query = ids.map((id) => `jobIds=${encodeURIComponent(id)}`).join('&')
        const response = await Api.get(`${apiBaseUrl}/Fleet/pressure-channels?${query}`)
        return Array.isArray(response?.data?.units) ? response.data.units : []
    }

    swapFleetStandardChannelFieldsOrder = async ({ fieldId1, fieldId2 }) => {
        const id1 = Number(fieldId1)
        const id2 = Number(fieldId2)
        if (!Number.isFinite(id1) || !Number.isFinite(id2)) {
            throw new Error('fieldId1 and fieldId2 must be valid numbers')
        }
        if (id1 === id2) {
            throw new Error('fieldId1 and fieldId2 must be different')
        }
        return Api.put(`${apiBaseUrl}/Fleet/standard-channel-fields/swap-order`, {
            FieldId1: id1,
            FieldId2: id2,
        })
    }

}

const dmsApiServiceInstance = new DmsApiService();

export default dmsApiServiceInstance;
